/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RealizationSavingsListRequest {
    getFixupPrototypeFunction() { return RealizationSavingsListRequest.fixupPrototype; }

    static newInstance(model: Partial<RealizationSavingsListRequest>): RealizationSavingsListRequest {
        let obj = Object.assign(new RealizationSavingsListRequest(), model);
        RealizationSavingsListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RealizationSavingsListRequest>): RealizationSavingsListRequest {
        if (!model) return null;
        return RealizationSavingsListRequest.newInstance(<RealizationSavingsListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RealizationSavingsListRequest) {
        if (!obj) return;

        models.RealizationSavingsListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RealizationSavingsListRequest): boolean {
        Object.setPrototypeOf(obj, RealizationSavingsListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.RecommendationListFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.RealizationSavingDashboardSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.RealizationSavingDashboardSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.RecommendationListFilters;

}
